import React, { useState, useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Form } from '@unform/web';
import PropTypes from 'prop-types';
import * as Yup from 'yup';
import { assign } from 'lodash';

import { Spinner } from '~/components';
import { Input, Autocomplete, Select } from '~/components/Form';
import { t } from '~/helpers';
import {
  storeTanqueFisico,
  updateTanqueFisico,
} from '~/store/modules/tanquefisico/actions';

import { Container } from './styles';
import { SelectComplete } from '~/componentslocal';

export default function CreateOrUpdate({ reference, data, create }) {
  const dispatch = useDispatch();

  const [posto, setPosto] = useState({ poco_codigo: '', poco_descricao: '' });
  const [automatico, setAutomatico] = useState(false);
  const [fields, setFields] = useState({ tavi_nome: '', arqu_descricao: '' });

  const [tavi, setTavi] = useState({ tavi_nome: '' })
  const [arq, setArq] = useState({ arqu_descricao: '' })

  const { loading, find, params } = useSelector((state) => state.tanquefisico);
  const initials = create ? data : { ...find, ...data };

  const handleSubmit = useCallback(
    async (param) => {
      try {
        const schema = Yup.object().shape({
          tafi_codigo: Yup.string()
            .required(t('s.geral.validacao.campoobrigatorio'))
            .min(2, t('s.geral.validacao.tamanhominimo').replace('%s', 2))
            .max(10, t('s.geral.validacao.tamanhomaximo').replace('%s', 10)),
          tafi_nome: Yup.string()
            .required(t('s.geral.validacao.campoobrigatorio'))
            .min(2, t('s.geral.validacao.tamanhominimo').replace('%s', 2))
            .max(30, t('s.geral.validacao.tamanhomaximo').replace('%s', 30)),
          poco_codigo: Yup.string()
            .required(t('s.geral.validacao.campoobrigatorio'))
            .max(10, t('s.geral.validacao.tamanhomaximo').replace('%s', 10))
            .nullable(),
          tavi_codigo: Yup.string().required(
            t('s.geral.validacao.campoobrigatorio')
          ),
          tafi_capacidade: Yup.string()
            .matches(/^[0-9]+$/, 'Valor deve ser inteiro')
            .required(t('s.geral.validacao.campoobrigatorio'))
            .test('Only decimal',
              'Deve ser um valor inteiro maior que 0',
              (value) => Number(value) > 0)
            .test('Only decimal',
              'Valor máximo ultrapassado',
              (value) => Number(value) <= 99999999)
          ,
          tafi_percent_esp_vazio: Yup.string()
            .matches(/^[0-9]+$/, 'Valor deve ser inteiro')
            .required('Valor deve ser inteiro')
            .test('decimal',
              'Valor deve ser no máximo 100',
              (value) => Number(value) <= 100),
          arqu_codigo: Yup.string()
            .required(t('s.geral.validacao.campoobrigatorio'))
            .nullable(),
          tafi_automatico: Yup.number().required(
            t('s.geral.validacao.campoobrigatorio')
          ),
          tafi_modelo: Yup.string().required(
            t('s.geral.validacao.campoobrigatorio')
          ),
          tafi_ip_concentrador: automatico
            ? Yup.string()
              .typeError(t('s.geral.validacao.campoobrigatorio'))
              .required(t('s.geral.validacao.campoobrigatorio'))
              .min(7, t('s.geral.validacao.tamanhominimo').replace('%s', 7))
              .max(15, t('s.geral.validacao.tamanhomaximo').replace('%s', 15))
            : Yup.string().nullable(),
          tafi_numero_sonda: automatico
            ? Yup.number()
              .required(t('s.geral.validacao.campoobrigatorio'))
              .min(1, 'Valor mínimo permitido 1')
              .max(8, 'Valor máximo permitido 8')
            : Yup.string().nullable(true),
          tafi_status: Yup.number()
            .required(t('s.geral.validacao.campoobrigatorio'))
            .min(1, t('s.geral.validacao.tamanhominimo').replace('%s', 1))
            .max(3, t('s.geral.validacao.tamanhomaximo').replace('%s', 3)),
        });

        await schema.validate(param, {
          abortEarly: false,
        });

        const objSend = {
          poco_descricao: '',
          prod_codigo: 0,
          prod_descricao: '',
          arqu_descricao: '',
          tafi_automatico_string: '',
          tafi_modelo_string: '',
          tafi_manutencao: '',
          tafi_volume_agua: '',
          tafi_cm_agua: '',
          tafi_data_ultima_leitura: '',
          tafi_volume_cont: '',
          tafi_volume_med: '',
          ...initials,
          ...param,
        };

        if (create) dispatch(storeTanqueFisico(objSend, params));
        else dispatch(updateTanqueFisico(objSend, params));
      } catch (err) {
        const validationErrors = {};

        if (err instanceof Yup.ValidationError) {
          err.inner.forEach((error) => {
            validationErrors[error.path] = error.message.replace(
              `${error.path} `,
              ''
            );
          });

          reference.current.setErrors(validationErrors);
        }
      }
    },
    [automatico, create, initials]
  );

  const handleSetValue = useCallback((field, value) => {
    reference.current.setFieldValue(field, value);
  }, []);

  // const handleChangePost = useCallback(
  //   (value) => {
  //     setPosto(value);


  //     if (create) {
  //       handleSetValue('tavi_codigo', '');
  //       handleSetValue('arqu_codigo', '');
  //       handleSetValue('tavi_nome', '');
  //     }
  //   },
  //   [create]
  // );
  useEffect(() => {
    setTavi({ tavi_nome: '' })
    setArq({ arqu_descricao: '' })
  }, [posto])



  return (
    <Container>
      {loading ? (
        <div style={{ height: '14rem', width: '50rem' }}>
          <Spinner loading />
        </div>
      ) : (
        <>
          <Form
            ref={reference}
            initialData={assign(
              { tafi_automatico: 0, tafi_modelo: 0, tafi_status: 1 },
              initials
            )}
            onSubmit={handleSubmit}
          >
            <Input name="tafi_codigo" label="Código" disabled={!create} />

            <Input name="tafi_nome" label="Nome" />

            <Autocomplete
              name="poco_codigo"
              label="poco_descricao"
              title="Posto"
              url="postoscomboios"
              unique="poco_codigo"
              disabled={!create}
              hiddens={[{ name: 'poco_descricao' }]}
              getValue={(value) => setPosto(value)}
            />

            <SelectComplete
              name="tavi_codigo"
              label="tavi_nome"
              title="Tanque Virtual"
              url="tanquevirtual"
              unique="tavi_codigo"
              disabled={!posto.poco_codigo || !create}
              disableClearable={!tavi.tavi_nome}
              inputValue={tavi.tavi_nome}
              onInputChange={(_, value) =>
                setTavi({ tavi_nome: value })
              }
              params={{
                wherefield: 'poco_codigo',
                valuewherefield: posto.poco_codigo,
                typewherefield: 'EQUALS',
              }}
            />

            <Input name="tafi_capacidade" label="Capacidade" type="number" />

            <Input
              name="tafi_percent_esp_vazio"
              label="% segurança"
              type="number"
            />

            <SelectComplete
              name="arqu_codigo"
              label="arqu_descricao"
              title="Tabela Arqueação"
              url="arqueacoes"
              disabled={!posto.poco_codigo}
              disableClearable={!arq.arqu_descricao}
              inputValue={arq.arqu_descricao}
              onInputChange={(_, value) =>
                setArq({ arqu_descricao: value })
              }
              unique="arqu_codigo"
              hiddens={[{ name: 'arqu_descricao' }]}
              params={{
                wherefield: 'poco_codigo',
                valuewherefield: posto.poco_codigo,
                typewherefield: 'EQUALS',
              }}
            />

            <Select
              name="tafi_automatico"
              label="Automático"
              options={[
                { value: 0, label: 'Não' },
                { value: 1, label: 'Sim' },
              ]}
              getValue={(value) => setAutomatico(Boolean(value))}
            />

            <Input
              name="tafi_ip_concentrador"
              label="IP concentrador"
              disabled={!automatico}
              inputProps={{ maxLength: 15 }}
            />

            <Input
              name="tafi_numero_sonda"
              label="Número Sonda"
              type="number"
              disabled={!automatico}
              InputProps={{ inputProps: { max: 8 } }}
            />

            <Select
              name="tafi_modelo"
              label="Modelo"
              options={[
                { value: 0, label: 'Vertical' },
                { value: 1, label: 'Horizontal' },
              ]}
            />

            <Select
              name="tafi_status"
              label="Status"
              options={[
                { value: 1, label: 'Liberado' },
                { value: 2, label: 'Bloqueado' },
                { value: 3, label: 'Cancelado' },
              ]}
            />
          </Form>
        </>
      )}
    </Container>
  );
}

CreateOrUpdate.propTypes = {
  reference: PropTypes.objectOf(PropTypes.any).isRequired,
  create: PropTypes.bool.isRequired,
  data: PropTypes.objectOf(PropTypes.any),
};

CreateOrUpdate.defaultProps = {
  data: {},
};
